/** Shared helpers for analysis document uploads (PDF + Excel). */

export const ANALYSIS_DOCUMENT_ACCEPT = '.pdf,.xlsx,.xls';
export const ANALYSIS_DOCUMENT_MAX_BYTES = 15 * 1024 * 1024;

const EXCEL_MIMES = new Set([
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
]);

export function getAnalysisDocumentExtension(nameOrPath) {
  if (!nameOrPath || typeof nameOrPath !== 'string') return '';
  const match = nameOrPath.toLowerCase().match(/\.(pdf|xlsx|xls)$/);
  return match ? `.${match[1]}` : '';
}

export function getAnalysisDocumentKind(nameOrPathOrFile) {
  if (nameOrPathOrFile && typeof nameOrPathOrFile === 'object') {
    const byName = getAnalysisDocumentExtension(nameOrPathOrFile.name || '');
    if (byName === '.pdf') return 'pdf';
    if (byName === '.xlsx' || byName === '.xls') return 'excel';
    if (nameOrPathOrFile.type === 'application/pdf') return 'pdf';
    if (EXCEL_MIMES.has(nameOrPathOrFile.type)) return 'excel';
    return 'unknown';
  }
  const ext = getAnalysisDocumentExtension(String(nameOrPathOrFile || ''));
  if (ext === '.pdf') return 'pdf';
  if (ext === '.xlsx' || ext === '.xls') return 'excel';
  return 'unknown';
}

export function isAllowedAnalysisDocument(file) {
  if (!file) return false;
  const kind = getAnalysisDocumentKind(file);
  return kind === 'pdf' || kind === 'excel';
}

export function getAnalysisDocumentTypeLabel(kind) {
  if (kind === 'pdf') return 'PDF';
  if (kind === 'excel') return 'Excel';
  return 'Document';
}

export function getAnalysisDocumentFilename(analysisName, pathOrFile) {
  const base = (analysisName || 'analysis').trim() || 'analysis';
  if (pathOrFile && typeof pathOrFile === 'object' && pathOrFile.name) {
    const ext = getAnalysisDocumentExtension(pathOrFile.name);
    return ext ? `${base}_analysis${ext}` : `${base}_analysis`;
  }
  const ext = getAnalysisDocumentExtension(String(pathOrFile || ''));
  if (ext) {
    const lowerBase = base.toLowerCase();
    if (lowerBase.endsWith(ext)) return base;
    return `${base}_analysis${ext}`;
  }
  return `${base}_analysis.pdf`;
}
